module.exports = __webpack_public_path__ + "img/tetris-piece-2.7d3489b2.svg";